import { CSSProperties, FC } from 'react';
import styled from 'styled-components';
import { useUIContext } from '../../context/UIContext';
import { Collector, CollectorStatus } from '../../models/Collector';
import { API } from '../../utils/API';
import { COLORS } from '../../utils/Colors';
import { Separator } from '../Separator';
import { ModalContainer } from './ModalContainer';

const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
`;

const Button = styled.button`
  color: ${COLORS.WHITE};
  border: none;
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  padding: 10px 20px;
`;

interface CollectorStatusChangeModalProps {
  onCancel: () => void;
  collector: Collector;
  statusToChangeTo?: CollectorStatus;
  setCollector: (collector: Collector) => void;
}

export const CollectorStatusChangeModal: FC<CollectorStatusChangeModalProps> = ({
  onCancel,
  collector,
  statusToChangeTo,
  setCollector
}) => {
  const styles = {
    iconContainer: {
      width: 100,
      height: 100,
      background: COLORS.GREEN_2_OPACITY,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      borderRadius: 50,
    } as CSSProperties,
    body: {
      textAlign: 'center',
    } as CSSProperties,
  };
  const { toast } = useUIContext();


  const handleChangeCollectorStatus = async () => {
    if (!statusToChangeTo) return;
    try {
      await API.Users.updateCollectorStatus(collector.id, statusToChangeTo);
      setCollector({ ...collector, status: statusToChangeTo });
      toast.showToast('Collector status updated successfully', 'SUCCESS');
    } catch (error: any) {
      console.error(error);
      toast.showToast(error.message, 'ERROR');
    } finally {
      onCancel();
    }
  };

  return (
    <ModalContainer>
      <span style={styles.body}>Status will be updated to {statusToChangeTo}</span>
      <Separator size="S" />
      <ButtonsContainer>
        <Button type='button' onClick={handleChangeCollectorStatus} style={{ background: COLORS.BLUE }}>
          <span>Confirm</span>
        </Button>
        <Separator size="XS" orientation='H' />
        <Button type='button' onClick={onCancel} style={{ background: COLORS.RED }}>
          <span>Cancel</span>
        </Button>
      </ButtonsContainer>
    </ModalContainer>
  );
};
